/**
 * Why a recording couldn't start. Kept apart from the recorder itself, so code
 * that only needs to recognise the error doesn't load the muxer with it.
 */
export class RecorderError extends Error {
  constructor(readonly reason: 'no-encoder' | 'nothing-to-record') {
    super(reason);
    this.name = 'RecorderError';
  }
}
